import { Divider } from '@rbilabs/universal-components';
import { centsToDollarString } from 'utils';

import { IVendorConfig } from '@rbi-ctg/menu';
import { Box, Typography } from 'components/ui';

import { CopyButton } from './copy-button';
import { PluInfo } from './plu-info-debug';
import { IDebugPosIdsConfiguration } from './use-debug-menu-item-data';

const POS_CONFIGURATION_FIELDS = [
  ['plu', 'PLU'],
  ['deliveryPlu', 'Delivery PLU'],
  ['combo', 'Combo'],
  ['container', 'Container'],
] as const;

const PRICE_STATUS_LABELS = {
  loading: 'One Menu price: Loading',
  'entry-not-found': 'One Menu price: Entry not found',
  'price-not-configured': 'One Menu price: Not configured',
} as const;

export const hasDisplayablePosIdsConfiguration = (
  posIdsConfiguration?: IDebugPosIdsConfiguration
) =>
  Boolean(
    posIdsConfiguration &&
      (POS_CONFIGURATION_FIELDS.some(([field]) => posIdsConfiguration[field]) ||
        posIdsConfiguration.injectionMode ||
        posIdsConfiguration.injectionType)
  );

export const OneMenuInfo = ({
  entryId,
  posIdsConfiguration,
  price,
  priceStatus,
}: {
  entryId: string;
  posIdsConfiguration?: IDebugPosIdsConfiguration;
  price?: number;
  priceStatus: 'loading' | 'entry-not-found' | 'price-not-configured' | 'available';
}) => {
  const configuredFields = POS_CONFIGURATION_FIELDS.filter(
    ([field]) => posIdsConfiguration?.[field]
  );
  const shouldDisplayPosIdsConfiguration = hasDisplayablePosIdsConfiguration(posIdsConfiguration);

  return (
    <Box>
      <CopyButton label={`One Menu ID: ${entryId}`} textToCopy={entryId} />
      {priceStatus === 'available' && price !== undefined ? (
        <CopyButton
          label={`One Menu price: $${centsToDollarString(price)}`}
          textToCopy={centsToDollarString(price)}
        />
      ) : (
        <Typography variant="copyOne" my="$2">
          {PRICE_STATUS_LABELS[priceStatus as Exclude<typeof priceStatus, 'available'>]}
        </Typography>
      )}
      {shouldDisplayPosIdsConfiguration && posIdsConfiguration ? (
        <Box>
          <Typography variant="headerTwo" mt="$2">
            POS IDs Configuration:
          </Typography>
          {configuredFields.map(([field, label], index) => {
            const vendorConfig = posIdsConfiguration[field];
            if (!vendorConfig) {
              return null;
            }

            return (
              <Box key={field}>
                {index > 0 ? <Divider /> : null}
                <Typography variant="copyOne" mt="$2">
                  {label}:
                </Typography>
                <PluInfo vendorConfig={(vendorConfig as unknown) as IVendorConfig} hidePrices />
              </Box>
            );
          })}
          {posIdsConfiguration.injectionMode ? (
            <CopyButton
              label={`Injection mode: ${posIdsConfiguration.injectionMode}`}
              textToCopy={posIdsConfiguration.injectionMode}
            />
          ) : null}
          {posIdsConfiguration.injectionType ? (
            <CopyButton
              label={`Injection type: ${posIdsConfiguration.injectionType}`}
              textToCopy={posIdsConfiguration.injectionType}
            />
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};
